import React, { useEffect, useState } from 'react';
import './DocScanResultPage.css';

const DocScanResultPage = ({ isError, errorMessage, onRedirect }) => {
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    // Auto-scroll to hide address bar on mobile browsers
    const hideAddressBar = () => {
      setTimeout(() => {
        window.scrollTo(0, 1);
      }, 100);
    };
    hideAddressBar();
    window.addEventListener('orientationchange', hideAddressBar);
    
    setCountdown(3);
    const interval = setInterval(() => {
      setCountdown((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    const timer = setTimeout(() => {
      onRedirect();
    }, 3000);
    
    return () => {
      clearInterval(interval);
      clearTimeout(timer);
      window.removeEventListener('orientationchange', hideAddressBar);
    };
  }, [onRedirect]);

  return (
    <div className="docscan-container">
      <div className="docscan-header">
        <div className="docscan-back-btn" onClick={() => window.history.back()}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M21 12C21 12.4142 20.6642 12.75 20.25 12.75H5.56031L11.0306 18.2194C11.3237 18.5124 11.3237 18.9876 11.0306 19.2806C10.7376 19.5737 10.2624 19.5737 9.96937 19.2806L3.21937 12.5306C3.07854 12.3899 2.99941 12.1991 2.99941 12C2.99941 11.8009 3.07854 11.6101 3.21937 11.4694L9.96937 4.71938C10.2624 4.42632 10.7376 4.42632 11.0306 4.71938C11.3237 5.01243 11.3237 5.48757 11.0306 5.78062L5.56031 11.25H20.25C20.6642 11.25 21 11.5858 21 12Z" fill="#121217"/>
          </svg>
        </div>
        <div className="docscan-headline">Schritt 1/2: Ausweisüberprüfung</div>
      </div>
      <div className="docscan-content-section">
        <div className="docscan-checkmark-container">
          {isError ? (
            <svg width="194" height="194" viewBox="0 0 194 194" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="97" cy="97" r="92" fill="#E53935"/>
              <path d="M124 70L70 124" stroke="white" strokeWidth="9" strokeLinecap="round"/>
              <path d="M70 70L124 124" stroke="white" strokeWidth="9" strokeLinecap="round"/>
            </svg>
          ) : (
            <svg width="194" height="194" viewBox="0 0 194 194" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="97" cy="97" r="92" fill="#2970CC"/>
              <path d="M69.4 97L87.8 115.4L124.6 78.6" fill="#2970CC"/>
              <path d="M69.4 97L87.8 115.4L124.6 78.6" stroke="white" strokeWidth="9" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          )}
        </div>
        <div className="docscan-text-block">
          <h2>{isError ? 'ID Scan fehlgeschlagen' : 'ID Scan erfolgreich'}</h2>
          <p style={{ fontWeight: 500, fontSize: 18, margin: 0 }}>
            {isError
              ? (errorMessage || 'Es gab ein Problem bei der Ausweisüberprüfung.')
              : 'Sie werden in Kürze automatisch weitergeleitet.'}
          </p>
          <p style={{ color: '#888', marginTop: 12, fontSize: 16 }}>
            {isError
              ? `Zurück zum Start in ${countdown} Sekunden...`
              : `Weiter in ${countdown} Sekunden...`}
          </p>
        </div>
      </div>
      <div style={{ height: 72, width: '100%' }}></div>
    </div>
  );
};

export default DocScanResultPage;
